import ApiService from "@/core/services/api.service";
import state from "./state";

export default {
  /**
   * Fetch Teacher Leave application list.
   *
   * @param context
   */
  async fetchTeacherLeaveApplicationApprovalList(context) {
    try {
      context.commit("setTeacherLeaveApplicationApprovalBusy", true);
      ApiService.setHeader();

      const res = await ApiService.query("school/leave/application/teacher", {
        params: {
          "page[number]": state.pagination.current_page ?? 1,
          "page[size]": state.size,
          "filter[base]": state.filters?.base,
        },
      });

      context.commit("setTeacherLeaveApplicationApprovalList", res.data.data);
      context.commit(
        "setTeacherLeaveApplicationApprovalListPagination",
        res.data.meta.pagination
      );

      return res;
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      context.commit("setTeacherLeaveApplicationApprovalBusy", false);
    }
  },

  /**
   * Change 'All' base filter.
   *
   * @param context
   * @param payload
   */
  changeTeacherLeaveApplicationApprovalBaseFilter(context, payload) {
    console.log(payload);

    const filters = state.filters;
    filters.base = payload.query;

    context.commit("setTeacherLeaveApplicationApprovalFilters", filters);
  },
};
